module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "OT"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC3#_idTOCAnchor-2"
    }
  }, [_vm._v("Editors’ Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC4#_idTOCAnchor-3"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC5#_idTOCAnchor-14"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC5#_idTOCAnchor-13"
    }
  }, [_vm._v("Authors and Texts")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC5#_idTOCAnchor-12"
    }
  }, [_vm._v("Drawing Upon the Fathers of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC5#_idTOCAnchor-11"
    }
  }, [_vm._v("Remigius of Auxerre and Carolingian Biblical Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC5#_idTOCAnchor-10"
    }
  }, [_vm._v("Allegory in Twelfth-­Century Monastic Interpretation: "), _c('br'), _vm._v("Rupert of Deutz")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC5#_idTOCAnchor-9"
    }
  }, [_vm._v("Hildegard of Bingen and the Interpretive Work of Medieval Women")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC5#_idTOCAnchor-8"
    }
  }, [_vm._v("The School of Saint Victor: "), _c('br'), _vm._v("Andrew of Saint Victor’s "), _c('span', {
    staticClass: "h1emphasis"
  }, [_vm._v("Exposition on Genesis")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC5#_idTOCAnchor-7"
    }
  }, [_vm._v("Creating Resources for Medieval Students: "), _c('br'), _vm._v("Peter Comestor and the "), _c('span', {
    staticClass: "h1emphasis"
  }, [_vm._v("Scholastic History")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC5#_idTOCAnchor-6"
    }
  }, [_vm._v("Nicholas of Lyra: A Fourteenth-­Century Exegete")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC5#_idTOCAnchor-5"
    }
  }, [_vm._v("Literal and Mystical Exegesis in the Fifteenth Century: "), _c('br'), _vm._v("Denis the Carthusian")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC5#_idTOCAnchor-4"
    }
  }, [_vm._v("About This Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1"
  }, [_vm._v("TRANSLATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC6#_idTOCAnchor-15"
    }
  }, [_vm._v("Remigius of Auxerre")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC7#_idTOCAnchor-16"
    }
  }, [_vm._v("Rupert of Deutz")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC8#_idTOCAnchor-17"
    }
  }, [_vm._v("Hildegard of Bingen")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC9#_idTOCAnchor-18"
    }
  }, [_vm._v("Andrew of Saint Victor")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC10#_idTOCAnchor-19"
    }
  }, [_vm._v("Peter Comestor")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC11#_idTOCAnchor-20"
    }
  }, [_vm._v("Nicholas of Lyra")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC12#_idTOCAnchor-21"
    }
  }, [_vm._v("Denis the Carthusian")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC13#_idTOCAnchor-22"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC14#_idTOCAnchor-23"
    }
  }, [_vm._v("Index of Names")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC15#_idTOCAnchor-24"
    }
  }, [_vm._v("Index of Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC16#_idTOCAnchor-25"
    }
  }, [_vm._v("Index of Scripture References")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1223c4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Schroeder_Genesis_text_CC-2.vue
// module id = 60
// module chunks = 0